import React__default, { forwardRef, useRef } from 'react';
import styled from 'styled-components';
import { StepsProvider } from './StepsContext.js';
import { useStepSizeContext } from './StepSizeContext.js';
import { useRefObjectAsForwardedRef } from '../../hooks/useRefObjectAsForwardedRef.js';
import { useMediaQuery } from '../../hooks/useMediaQuery.js';
import Box from '../Box/Box.js';

const Steps = /*#__PURE__*/forwardRef(({
  ...props
}, forwardedRef) => {
  const innerRef = useRef(null);
  useRefObjectAsForwardedRef(forwardedRef, innerRef);
  const {
    UNSAFE_className,
    activeStep = 0,
    children,
    orientation: orientationProp,
    state,
    responsive,
    checkIcon,
    onSelectStep,
    labelOrientation,
    ariaLabel,
    ...rest
  } = props;
  const childArr = React__default.Children.toArray(children);
  const [stepCount, setStepCount] = React__default.useState(childArr.length);
  const {
    size
  } = useStepSizeContext();
  const renderHorizontalContent = () => {
    if (activeStep <= childArr.length) {
      return React__default.Children.map(childArr[activeStep], node => {
        if (! /*#__PURE__*/React__default.isValidElement(node)) return;
        // @TODO, this is a bit too terse
        return React__default.Children.map(node.props.children, childNode => childNode);
      });
    }
    return null;
  };
  const clickable = !!onSelectStep;
  const [isMobile] = useMediaQuery('(max-width: 43em)');
  const orientation = isMobile && responsive ? 'vertical' : orientationProp;
  return /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      textAlign: 'center',
      width: '100%',
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React__default.createElement(StepsProvider, {
    value: {
      activeStep,
      orientation,
      state,
      responsive,
      checkIcon,
      onSelectStep,
      labelOrientation,
      clickable,
      stepCount,
      UNSAFE_className
    }
  }, /*#__PURE__*/React__default.createElement(OrderedList, {
    as: "ol",
    orientation: orientation,
    stepCount: stepCount,
    "aria-label": ariaLabel
    // @TODO: handle ref, TS is getting the better of me here - M.O.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    ,
    ref: innerRef
  }, React__default.Children.map(children, (child, i) => {
    var _ref;
    const isCompletedStep = (_ref = /*#__PURE__*/React__default.isValidElement(child) && child.props.isCompletedStep) !== null && _ref !== void 0 ? _ref : i < activeStep;
    const isLastStep = i === stepCount - 1;
    const isCurrentStep = i === activeStep;
    const stepProps = {
      index: i,
      isCompletedStep,
      isCurrentStep,
      isLastStep,
      size
    };
    if ( /*#__PURE__*/React__default.isValidElement(child)) {
      return /*#__PURE__*/React__default.cloneElement(child, stepProps);
    }
    return null;
  })), orientation === 'horizontal' && renderHorizontalContent()));
});
const OrderedList = styled(Box).withConfig({
  displayName: "Steps__OrderedList",
  componentId: "sc-74ecm3-0"
})(["justify-content:", ";flex-direction:", ";text-align:center;width:100%;display:flex;flex:1;> * + *{margin-block-start:", ";}"], p => p.stepCount === 1 ? 'flex-end' : 'space-between', p => p.orientation === 'vertical' ? 'column' : 'row', p => p.orientation === 'vertical' ? '12px' : 'revert');
Steps.displayName = 'Steps';
var Steps$1 = Steps;

export { Steps$1 as default };
